/* eslint-disable no-unused-vars */

import React from 'react';
import { connect } from 'react-redux';

import { HELP_LINKS } from 'constants/helpCenterLinks.const';
import { withIsFromMobileApp } from 'hooks/useIsFromMobileApp.hook';
import { withGilt, withTranslation } from 'providers/GILT.provider';
import { selectCurrentSalonCountryCode, selectCurrentSalonCurrency } from 'selectors/currentSalon.selectors';

import ComponentToPrint from 'reports/Common/ComponentToPring';
import { TipsCard } from 'reports/Common/TipsCard.component';
import ProductSales from 'reports/RetailReport/ProductSales';
import ProductSalesByStylist from 'reports/RetailReport/ProductSalesByStylist';
import RetailPerformanceTable from 'reports/RetailReport/RetailPerformanceTable';
import { calculateTotalsOnProductSalesData, calculateTotalsOnServiceSalesData } from 'reports/sales.bl';
import { convertStylistsMapsToStylistTableData } from 'reports/utils';
const ReportsProps = ['salesReport', 'productSalesReport', 'productSalesByStylistReport'];

class RetailLayout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.componentRef = React.createRef();
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  checkIfAllDataIsLoaded = () => ReportsProps.every((prop) => this.props[prop].lastRequestResponse);

  render() {
    let revenueData;
    const currencyAbbr = this.props.currency;
    const { uniqueVisitsReport, t, formatDate, countryCode } = this.props;

    const tips = [{ description: t('businessReports.retail.proTipDescription1') }, { description: t('businessReports.retail.proTipDescription2') }];

    const helpLink = HELP_LINKS[countryCode].retailReportsHelpLink || HELP_LINKS.GB.retailReportsHelpLink;

    if (this.checkIfAllDataIsLoaded()) {
      const stylistGroup = this.props.salesReport.lastRequestResponse.stylist_group;

      const nameServicesTotalPriceMap = {};
      stylistGroup.forEach((stylist) => {
        nameServicesTotalPriceMap[stylist.name] = calculateTotalsOnServiceSalesData(stylist.services);
      });
      const nameProductsTotalPriceMap = {};
      stylistGroup.forEach((stylist) => {
        nameProductsTotalPriceMap[stylist.name] = calculateTotalsOnProductSalesData(stylist.products);
      });

      revenueData = convertStylistsMapsToStylistTableData(nameServicesTotalPriceMap, nameProductsTotalPriceMap, currencyAbbr, t);
    }
    return (
      <div className="has-protipbox">
        <div className="new-wraper">
          <div className="performance p1 box retail">
            {!this.checkIfAllDataIsLoaded() && (
              <div className="spinner-container">
                <div className="load-spinner" />
              </div>
            )}
            {this.checkIfAllDataIsLoaded() && revenueData && (
              <React.Fragment>
                <TipsCard tips={tips} url={helpLink} printTargetRef={() => this.componentRef.current} />

                <ComponentToPrint ref={this.componentRef} componentRef>
                  <RetailPerformanceTable
                    startDate={formatDate(uniqueVisitsReport.start_date, { hideTime: true, hideWeekday: true })}
                    endDate={formatDate(uniqueVisitsReport.end_date, { hideTime: true, hideWeekday: true })}
                    revenueData={revenueData}
                    salesReport={this.props.salesReport.lastRequestResponse}
                    uniqueClientsReport={this.props.uniqueClientsReport.lastRequestResponse}
                    stylistList={this.props.stylistList}
                  />
                  <ProductSales
                    startDate={formatDate(uniqueVisitsReport.start_date, { hideTime: true, hideWeekday: true })}
                    endDate={formatDate(uniqueVisitsReport.end_date, { hideTime: true, hideWeekday: true })}
                    productSales={this.props.productSalesReport}
                  />
                  <ProductSalesByStylist
                    startDate={formatDate(uniqueVisitsReport.start_date, { hideTime: true, hideWeekday: true })}
                    endDate={formatDate(uniqueVisitsReport.end_date, { hideTime: true, hideWeekday: true })}
                    productSalesByStylist={this.props.productSalesByStylistReport}
                  />
                </ComponentToPrint>
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    currentSalon: { id: salonId, stylistList },
    reports,
    clientCommunications: { clientList },
  } = state;
  const { salesReport, uniqueVisitsReport, rebookingReport, uniqueClientsReport, visitFrequencyReport, lastDatesSelected, appointmentsReport, productSalesReport, productSalesByStylistReport } =
    reports;
  const currency = selectCurrentSalonCurrency(state);
  const countryCode = selectCurrentSalonCountryCode(state);
  return {
    salonId,
    clientList,
    lastDatesSelected,
    salesReport,
    uniqueVisitsReport,
    rebookingReport,
    uniqueClientsReport,
    visitFrequencyReport,
    appointmentsReport,
    stylistList,
    productSalesReport,
    productSalesByStylistReport,
    currency,
    countryCode,
  };
}

export default connect(mapStateToProps)(withIsFromMobileApp(withGilt(withTranslation()(RetailLayout))));
